import { useCallback, useState } from 'react';

import { Input } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { VideoUrlModel } from 'types/trackmanParameters';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { videoUrlValidator } from 'utilities/urlValidators';

export const ParameterVideos = observer(() => {
  const ps = useStores().parametersStore;
  const [videoError, setVideoError] = useState(false);

  const handleOnChange = useCallback((video: VideoUrlModel, newValue: string) => {
    setVideoError(false);
    if (videoUrlValidator(newValue) || newValue === '') {
      setVideoError(true);
    }
    video.videoUrl = newValue;
  }, []);

  return (
    <div className='admin-edit-section video-settings-wrapper'>
      <h2>Parameter videos</h2>
      <Paragraph>
        <span className={videoError ? 'error' : ''}>
          Please add only ID of the video, you can find it in the YouTube link eg. https://www.youtube.com/watch?v=
          <strong>xZoMV_ap4s4</strong>
        </span>
      </Paragraph>
      {ps.parameter.videoUrls.map((video, index) => {
        return (
          <div className='inputs-container' key={`video-${index}-${video.videoUrl}`}>
            <Input
              label='Video title'
              value={video.label ?? ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => (video.label = e.currentTarget.value)}
            />
            <Input
              label='Video ID'
              error={!video.videoUrl}
              value={video.videoUrl ?? ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(video, e.currentTarget.value)}
            />
            <button className='delete-button' onClick={() => ps.parameter.videoUrls.splice(index, 1)}>
              <TrashIcon />
            </button>
          </div>
        );
      })}
      <button className='styled-button secondary' onClick={() => ps.parameter.videoUrls.push({ videoUrl: '', label: '' })}>
        Add video
      </button>
    </div>
  );
});

export default ParameterVideos;
